import { createAsyncThunk } from '@reduxjs/toolkit'
import mainTranslate from 'loankeeper-common/helpers/language'
import { PrintReportParams, PrintReportServerData } from '@lk/api'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'

const translate = (key) => mainTranslate(`LKMESSAGE-${key}`)

export const printReport = createAsyncThunk<PrintReportServerData, { params: PrintReportParams; body?: {} }, ThunkApi>(
  '[PRINT_REPORT] PRINT_REPORT',
  async ({ params, body = {} }, { dispatch, extra, rejectWithValue }) => {
    const { success, data, error } = await extra.api.printReport.get(params, body)

    if (success) {
      return data
    }

    const translatedErrorMessage = translate(error.message)

    dispatch(
      LKModalActions.openError(
        translatedErrorMessage === error.message
          ? mainTranslate('frm_web_messages-ERR_PRINT_SERVICE_UNAVAILABLE')
          : translatedErrorMessage,
      ),
    )
    return rejectWithValue('Error printing report')
  },
)
